import "./App.css"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import SanJose from "./sanjose"
import About from "./About"
import Privacy from "./Privacy"
import Terms from "./Terms"
import NotFound from "./NotFound"

function App() {
  return (
    <Router>
      <div className='App'>
        <Routes>
          <Route path='/' element={<SanJose />} />
          <Route path='/about' element={<About />} />
          <Route path='/privacy' element={<Privacy />} />
          <Route path='/terms' element={<Terms />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App
